import * as React from "react";
import { Body1, makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  container: {
    padding: "16px",
  }
});

const TimelineTab: React.FC = () => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <Body1>Timeline view coming soon...</Body1>
    </div>
  );
};

export default TimelineTab;
